import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ACL from '@components/ACL/ACL'

import Spinner from '@components/spinner'
import '../Sidebar.sass'
import ProjectsIcon from '@components/Icon/ProjectsIcon'
import RenderField from '../Components/RenderField'

class ClientAccount extends Component {
  static propTypes = {
    id: PropTypes.number,
    clientStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    contractStore: PropTypes.object
  }

  constructor (props) {
    super(props)
    const { clientStore, contractStore, id } = this.props
    clientStore.getProjectsCount(id)
    clientStore.getAccount(id, true)
    contractStore
      .getAccountContracts(id)
      .then(contracts => extendObservable(this, { contracts }))
  }

  renderContracts = () => {
    if (!this.contracts || this.contracts.length < 1) return <p>-</p>
    return this.contracts.map(contract => {
      return (
        <ACL
          roles={[
            'FeeManagement',
            'Accounting',
            'AdvancedExpertManagement',
            'ProjectManagement',
            'AdvancedReporting',
            'Admin'
          ]}
          alternative={<p key={contract.id}>{contract.contractReference}</p>}
        >
          <p
            key={contract.id}
            className='sidebar-wrapper__content__link'
            onClick={this.handleLinkClick}
          >
            <Link to={`/contract/${contract.id}`}>
              {contract.contractReference}
            </Link>
          </p>
        </ACL>
      )
    })
  }

  renderParentAccountInformation = parentAccount => {
    return (
      <div>
        <RenderField
          label='Operational guidelines'
          html={parentAccount.operationalGuidelines || '-'}
        />
        <RenderField
          label='Disclaimer comment'
          value={parentAccount.disclaimerComment || '-'}
        />
        <RenderField
          label='Case code'
          value={parentAccount.caseCodeRequired ? 'Required' : 'Not required'}
        />
        <RenderField
          label='Show submitted expert names on client interface'
          value={parentAccount.expertsDisclosed ? 'Yes' : 'No'}
        />
      </div>
    )
  }

  handleLinkClick = () => {
    const { sidebarStore } = this.props
    sidebarStore.closeSidebar()
  }

  render () {
    const { clientStore } = this.props
    const { account, parentAccount, loading, accountProjectCount } = clientStore

    if (loading) return <Spinner />
    if (!account || !parentAccount) return null

    return (
      <div>
        <h1
          className='sidebar-wrapper__content__link'
          onClick={this.handleLinkClick}
        >
          <Link to={`/account/${account.id}`}>{account.companyName}</Link>
        </h1>
        <div className='group'>
          <div className='icon-label'>
            <ProjectsIcon />
            <p>{accountProjectCount} projects</p>
          </div>
        </div>
        <RenderField
          label={account.companyName}
          className='sidebar-wrapper__rich-text rich-text--dark'
          html={account.operationalGuidelines || '-'}
        />
        <RenderField
          label='External Compliance Verification'
          value={
            account.externalComplianceRequired ? 'Required' : 'Not required'
          }
        />
        <h2>Atheneum key account managers</h2>
        <RenderField
          label='Key Atheneum contact'
          value={account.keyContact ? account.keyContact.fullName : '-'}
        />
        <RenderField
          label='Contracts in place'
          value={this.renderContracts()}
        />
        <div>
          <h2>Parent account operational guidelines</h2>
          {this.renderParentAccountInformation(parentAccount)}
        </div>
      </div>
    )
  }
}

export default inject(
  'sidebarStore',
  'clientStore',
  'staticData',
  'contractStore'
)(observer(ClientAccount))
